export enum LeftPaneSelectedTab {
  TREE_VIEW,
  ERRORS,
}
